import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DiscreteTabs from 'components/DesignSystem/Tabs/DiscreteTabs';
import mapAnnotations from 'helper/Meteorology/Weather/Overview/AnomalyPanel/mapAnnotations';
import OscillationTabs from 'components/Meteorology/Weather/Oscillations/Mobile/OscillationTabs';
import useIsMobile from 'utils/hooks/useIsMobile';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/weatherLayoutReducer';
import './index.scss';

export default function Oscillations() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('oscillations'));
  }, []);

  if (isMobile) {
    return (
      <>
        <OscillationTabs />
        <Outlet />
      </>
    );
  }

  return (
    <div>
      <DiscreteTabs
        type="underline"
        activeKey="./"
      >
        <DiscreteTabs.Tab path="/meteorology/weather/oscillations/" title="Visão Geral" />
        {
          mapAnnotations.map((entry) => (
            <DiscreteTabs.Tab path={`/meteorology/weather/oscillations/${entry.url}`} title={entry.acronym} />
          ))
        }
      </DiscreteTabs>
      <hr className="m-1" />
      <div>
        <Outlet />
      </div>
    </div>
  );
}
